import { render } from "./CourseInformationsTruncated.vue?vue&type=template&id=1bdff770&scoped=true"
import script from "./CourseInformationsTruncated.vue?vue&type=script&lang=js"
export * from "./CourseInformationsTruncated.vue?vue&type=script&lang=js"

import "./CourseInformationsTruncated.vue?vue&type=style&index=0&id=1bdff770&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdff770"]])

export default __exports__